import type { ValueOf } from 'type-fest';

import { FlagType } from '../../../../shared/featureFlags/flagNames';
import type { VisibleFlagName } from '../../../../shared/featureFlags/types';

export type OrgFlag = {
  id: VisibleFlagName;
  displayName: string;
  description: string;
  type: FlagType;
  isEnabled: boolean;
};

// Flag order is inferred from the order of the enum
// This assigns a number to determine order for the sort function
type FlagOrderType = Record<ValueOf<typeof FlagType>, number>;
const FlagOrder: FlagOrderType = Object.values(FlagType).reduce((acc, flagType, idx) => {
  acc[flagType] = idx;
  return acc;
}, {} as FlagOrderType);

/**
 * Method to sort OrgFlags for admin page - sorts by type and then displayName
 */
export function sortFlags(a: OrgFlag, b: OrgFlag) {
  const aPriority = FlagOrder[a.type];
  const bPriority = FlagOrder[b.type];

  if (aPriority === bPriority) {
    return a.displayName > b.displayName ? 1 : -1;
  }

  if (aPriority < bPriority) {
    return -1;
  }

  return 1;
}

/**
 * Produce a meaningful warning message about alpha and/or deprecated flag usage.
 */
export function problematicFlagMessage(
  alphaFlagChange: boolean,
  deprecatedFlagChange: boolean,
) {
  let message = '';
  if (alphaFlagChange && deprecatedFlagChange) {
    message =
      'These feature flags are still in development or are deprecated and may not work as expected or may not be supported.';
  } else if (alphaFlagChange) {
    message = 'These feature flags are still in development and may not work as expected.';
  } else if (deprecatedFlagChange) {
    message = 'These feature flags are deprecated and may not be supported any more.';
  }

  return message;
}
